import { FC } from 'react';

import { IconProps } from './types';

export const HelpEmptyIcon: FC<IconProps> = ({
	color = '#5390E9',
	height = 22,
	width = 22,
	size,
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size ?? width}
		height={size ?? height}
		viewBox="0 0 22 22"
	>
		<path
			fill={color}
			d="M11 0c6.065 0 11 4.93 11 11s-4.935 11-11 11S0 17.07 0 11 4.935 0 11 0zm0 2c-4.962 0-9 4.04-9 9s4.038 9 9 9c4.963 0 9-4.04 9-9s-4.037-9-9-9zm.01 11.984c.551 0 1 .45 1 1a1.002 1.002 0 0 1-2.006 0 1 1 0 0 1 1.005-1zm2.227-6.97c.363.47.762 1.1.762 1.97 0 1.95-2.396 2.85-2.669 2.94a.97.97 0 0 1-.33.06c-.414 0-.8-.26-.945-.67a.994.994 0 0 1 .613-1.27c.554-.2 1.331-.7 1.331-1.06 0-.18-.05-.37-.3-.7-.282-.3-.855-.39-1.299-.13-.2.1-.37.31-.506.58a1 1 0 0 1-1.342.44.993.993 0 0 1-.446-1.34c.235-.47.66-1.1 1.346-1.44 1.196-.7 2.81-.45 3.785.62z"
			fillRule="evenodd"
		/>
	</svg>
);
